// extracted by mini-css-extract-plugin
export var header = "_wh-1";
export var maskBottom = "_wh-6";
export var maskMiddle = "_wh-7";
export var maskTop = "_wh-5";
export var root = "_wh-0";
export var scrollDownButton = "_wh-3";
export var scrollDownButtonHidden = "_wh-4";
export var viewport = "_wh-2";